import React, { SVGProps } from "react";

const SvgRoof8 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 350 300"
    {...props}
  >
    <defs>
      <linearGradient
        id="roof8_svg__a"
        x1={243.958}
        y1={198.605}
        x2={217.03}
        y2={151.965}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.471} stopColor="#bdcddb" stopOpacity={0} />
        <stop offset={1} stopColor="#bdcddb" stopOpacity={0.35} />
      </linearGradient>
      <linearGradient
        id="roof8_svg__b"
        x1={63.284}
        y1={222.976}
        x2={90.307}
        y2={176.171}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.316} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="roof8_svg__d"
        x1={288.138}
        y1={222.03}
        x2={247.47}
        y2={151.591}
        xlinkHref="#roof8_svg__a"
      />
      <linearGradient
        id="roof8_svg__e"
        x1={201.171}
        y1={231.819}
        x2={228.835}
        y2={183.903}
        xlinkHref="#roof8_svg__b"
      />
      <linearGradient
        id="roof8_svg__c"
        x1={328.732}
        y1={113.738}
        x2={328.732}
        y2={87.993}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.117} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof8_svg__f"
        x1={21.399}
        y1={173.635}
        x2={21.399}
        y2={136.219}
        xlinkHref="#roof8_svg__c"
      />
      <linearGradient
        id="roof8_svg__g"
        x1={133.034}
        y1={226.849}
        x2={133.034}
        y2={201.104}
        xlinkHref="#roof8_svg__c"
      />
      <linearGradient
        id="roof8_svg__h"
        x1={308.778}
        y1={163.655}
        x2={308.778}
        y2={137.911}
        xlinkHref="#roof8_svg__c"
      />
      <linearGradient
        id="roof8_svg__i"
        x1={236.307}
        y1={214.269}
        x2={236.307}
        y2={188.523}
        xlinkHref="#roof8_svg__c"
      />
      <linearGradient
        id="roof8_svg__j"
        x1={193.765}
        y1={191.662}
        x2={193.765}
        y2={165.917}
        xlinkHref="#roof8_svg__c"
      />
    </defs>
    <path fill="none" d="M0 0h350v300H0z" />
    <path
      fill="url(#roof8_svg__a)"
      d="M132.645 200.81v62.062L328.343 149.76V87.698L132.645 200.81z"
    />
    <path
      fill="url(#roof8_svg__b)"
      d="M132.645 200.879v61.993L21.011 198.57v-62.406l111.634 64.715z"
    />
    <path
      fill="url(#roof8_svg__d)"
      d="M236.307 188.481v63.473l72.471-41.966v-71.904l-30.57-4.239-41.901 54.636z"
    />
    <path
      fill="url(#roof8_svg__e)"
      d="M236.307 188.481v63.473l-42.542-24.411v-63.888l42.542 24.826z"
    />
    <path
      fill="#2077aa"
      d="M340 81.333 133.033 201.104l-9.711-126.207 102.714-59.228L340 81.333z"
    />
    <path
      fill="#48d7ff"
      d="M225.854 15.774 123.322 74.897 10 129.78 217.252 10l8.602 5.774z"
    />
    <path
      fill="#4cf1ff"
      d="M133.033 201.104 10 129.78l113.322-54.883 9.711 126.207z"
    />
    <path
      fill="#45e1ff"
      d="m195.316 164.906 40.917 23.618 41.975-54.679-73.919-42.754-8.973 73.815z"
    />
    <path
      fill="#2682b5"
      d="m279.785 116.179 40.553 23.508-42.13-5.842-73.919-42.754 75.496 25.088z"
    />
    <path
      fill="none"
      strokeMiterlimit={10}
      stroke="url(#roof8_svg__c)"
      d="M328.732 113.738V87.993"
    />
    <path fill="url(#roof8_svg__f)" d="M20.899 136.219h1v37.416h-1z" />
    <path fill="url(#roof8_svg__g)" d="M132.534 201.104h1v25.745h-1z" />
    <path
      fill="none"
      stroke="#002839"
      strokeMiterlimit={10}
      d="m123.322 74.897 102.714-59.228"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      d="m195.316 164.906 8.973-73.815 73.58 42.558M204.289 91.091l75.496 25.088"
    />
    <path fill="url(#roof8_svg__h)" d="M308.278 137.911h1v25.745h-1z" />
    <path fill="url(#roof8_svg__i)" d="M235.807 188.523h1v25.745h-1z" />
    <path fill="url(#roof8_svg__j)" d="M193.265 165.917h1v25.745h-1z" />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      d="m133.034 201.105-9.712-126.208L10 129.781"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m279.785 116.179 40.553 23.508-42.469-6.038-41.562 54.832-40.991-23.575-62.282 36.199L10 129.781 217.253 10l8.783 5.669L340 81.333l-60.215 34.846z"
    />
  </svg>
);

export default SvgRoof8;
